var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tc-closeable-message"},[_c('span',[_vm._v(_vm._s(_vm.content))]),_c('x-icon',{attrs:{"type":"close"},on:{"click":function($event){return _vm.$emit('close')}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }